export default __webpack_public_path__ + "static/media/img7.1034735d.jpg";